import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiPython,
  DiHtml5,
  DiCss3,
  DiJavascript1,
  DiJava,
  DiMongodb,

  DiGit,
  DiReact,
  DiNodejs,
  DiAndroid,
  DiLaravel,
  DiCodeigniter,
} from "react-icons/di";
import {
  SiPostgresql,
  SiMysql,
  SiApacheairflow,
  
  SiRedis,
  SiFirebase,
  SiNextdotjs,
} from "react-icons/si";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb/>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
       <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <SiApacheairflow />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5/>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiCss3 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
      
    </Row>
  );
}

export default Techstack;
